import React from 'react';
import { checkLinkSubstitution } from '../../utils/functions';

const ExtensionButton = ({ extensionDetails }) => {

  const buttons = [1, 2, 3, 4, 5];
  const renderButtons = buttons.some(
    item => extensionDetails[`buttonbar${item}Btn`],
  );

  return (
    <div
      className="buttonbar-container"
      style={{
        backgroundColor: extensionDetails.background,
      }}>
      {renderButtons ? (
        buttons.map(
          item =>
            extensionDetails[`buttonbar${item}Btn`] && (
              <div className="buttonbar-buttonContainer" key={item}>
                <a
                  href={checkLinkSubstitution(extensionDetails[`targetWebsite${item}`])}
                  target="_blank"
                  rel="noopener noreferrer">
                  <button
                    className="buttonbar-button"
                    style={{
                      color: extensionDetails[`streamColor${item}`],
                      backgroundColor: extensionDetails[`barColor${item}`],
                    }}>
                    <span>{extensionDetails[`btnCaption${item}`]}</span>
                  </button>
                </a>
              </div>
            ),
        )
      ) : (
        <div className="">No Button Added</div>
      )}
    </div>
    // <iframe src='https://button-prod.meetn.com/overlay?id=rdqygMtzQvPiFJANsnWy&room=lovnish&extension=26999&extensionData=VTJGc2RHVmtYMS9WT2ZUMmdLWTBWb2lWWGJlQTN3dmlMZkowdUVmcmxpUFREQ3U4RDNLYW1kc2hQamIrU3YrQmxMN0xRT2hYRktPTlQxL2pRaFJKOFZnMmoyWnNWYjB5bnBoOTEzbmY2Rzc0NkR4UzBNc3Y2RW83MW14S1pHUFBjdDFkQld3T3lINzNhZ3Z3OWlSVllsUEI4RXhnbHd3bFVlY3B3bExZTVM1TkZqa2NHK0pHazNKQUdLbnQ4VXZKekdkNnA5eFFlWUpUb0xqenFhenZ3R3BINW5tNXFjRXRVclY3U0N5OWxVNWNEZUVkTzlhdDN5UUdNY3Qvek03Ky9vRThOeXRocHJZaXF6RnZIbHRPSXYvT0E1T2NGSkpFQUx4dTZCeDBzNFF2OGpMYmdhVC9GWGNxenY5aG5IUGxtY1hNVGlRWWhaNkdQNWdZVm9udUFOQzNqcFhpbDQxMjA3Vk9tNmx0RnNZTERZdHZZWFFqUDQwUStoR3JEbTN3TG8vVXFudHh3VVE2WFhBeFBGS1ZOelVnRWJpdm4zR0hQMlNJOTRSaXd0UDI4bWh3U0dNZkdrSy9DK0JjbFgrT1NJbHQvNlBwTTBNZXJQdXZSOWZWRjdodDFJcC9sMFpwNmdLOTg4U2wxVVpRWUowSXlGOFU4Vkt2bWs0b3pFUC9ILy8xdnlSTmdLVkNoQTAzcEJ0a1p4SWZEN1BiemNEbTRMSEVBZ2JQak1vNVZjbnFpSTZIOStMeXBsRGphcUZacjFUdkhPQ1paejFHOTg3VUNWMlNITFYrZVlCQ1hDZUdUeDB1YitUcllWVDR2aXljWG9taE9wY0RHUksrMndyVGE2QWhTQ3ZHei9WVk5GWXRSSy9jZFEvc1V3Q3Nva2lXSWY1ZDJwWHpQcHNkSVdYZWxPQWJGRHFRZDl0ME5NVi9ENURIeGJrQXNnTk5tQUkwbXk3ZXArYU1BckpwT3ZXdFNVUFFSazhScWNQbkJRWFFnWHhyOTFoRjk0NG82Ulk5T2plUmtYNEtSQ1FqMmEyTWR5amxaV3FKUFl3b29FaDZPejlyQkc2Y2QxbzNLekJTbGZQdzUwM01ZdkNQMWZmMXNhNFo3SEkxUFB1NmtKSlNESnZKcEdMaWdQNmF1ci82NE0zRDNtQlplcC9sTzdQaG9rQSt5UUpmUU85Yk9Gem9aaVhkUkZPQXFpSFQ0bGk0eVloYnhya1VIZE9rWUR6YmFBV2JERlFYdytDR1JNa2JsYlQ3MlIxSGEzbWxVNm96WncwTVdsSTdOL0RiMWpTUDBQb0hNcTQzUkdHUVlrSXd1N3E2NFdmbGxNZ0gva3RyeUY3QWVza1JBREsvQ3hMRWpWM2RJYlA3djFQeUpJTGFGSFFwVUV3NVFhY1J1aU5QNCtUVkNGZHBzM0VTNnRtVUpLZFNXSi9JT2RkcDI4WTREVHd3ZCtzb2hYd1FSRXBVdHFEcDF5Tk1aWTNrNEc3Mk1pdWxXUXJQQTVPbTg3RURWUWRmM0JyYWRnMG1jVGtkU2wxWW1xQWl3MkVqajJic2lMK0JQWXp6YXo2OGs5cEJZQ2RvanE3eXZtZkNCUmdoSG9hVk9UNWVWZyt6N2hSVWp6SEduSE1NazcvZm9NaVV0T0M5dk4yWGV6cXlnTkljTXVUcUFHVGlRN2tJRis0MzlTaGF3anRjZldPUnNHZUdBSHl4QmRUSlk5YWg4SWplZGRsd04vS1liekNidXBaeXVOVElEeXM2Q1dWQXJDbi8xV3JLVmZwc1BmaUVaYk9aZ1doNEs3aXl2VUgwZnI0OGV2dkpDSU1TckxQZHFVQ2VWeUJNdTBRcm5EdlI2M2VTc0FhUDNBTnhCU0dOUWhuMFdqdFVON1AyYkU1ZGVpL0ZxbnBka1ZpMVBld1l6elFDU2JqMG1GcXRVVGtFYUZrd2gxYnZyTEhSQkEzYWwxUkM%3D&auth=null&token=ccafdc359cc654820746'></iframe>
  );
};

export default ExtensionButton;
